import React from 'react';

import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { Icon } from '@shared/ui';

import cls from './MeasurementCard.module.css';
import {
    measurementsActions,
    measurementsSelector,
} from '../../../../store/slices/measurementsSlice/measurementsSlice';

export const MeasurementCard = ({ measurementId }) => {
    const measurement = useSelector((state) =>
        measurementsSelector.selectById(state, measurementId)
    );

    const { currentCardId } = useSelector((state) => state.measurementsReducer);

    const dispatch = useDispatch();

    if (!measurement) {
        return null;
    }

    const onClickCard = (event) => {
        event.stopPropagation();
        dispatch(measurementsActions.changeCurrentCardId(measurementId));
        if (`${measurementId}` !== `${currentCardId}`) dispatch(measurementsActions.resetOpening());
    };

    const cardTitle =
        measurement.name.length > 19 ? `${measurement.name.substring(0, 19)}...` : measurement.name;
    return (
        <div className={cls.Card} onClick={onClickCard}>
            {measurement?.is_from_ai && (
                <div className={cls.aiIcon}>
                    <Icon iconName="aiStars" width={24} height={24} />
                </div>
            )}
            <div
                className={classNames(cls.CardImg, {
                    [cls.CardImgEmpty]: !measurement.preview_url,
                })}
            >
                {measurement.preview_url ? (
                    <img
                        width={204}
                        height={132}
                        src={measurement.preview_url}
                        alt={measurement.name}
                        draggable="false"
                    />
                ) : (
                    <svg
                        width="52"
                        height="52"
                        viewBox="0 0 52 52"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M30.0185 8.72199C30.207 8.58746 30.4599 8.58746 30.6484 8.72199L39.5443 15.0763C39.5425 15.1062 39.5419 15.1364 39.5419 15.1668V30.3334C39.5419 30.6327 39.2992 30.8751 39.0002 30.8751H21.6669C21.3676 30.8751 21.1251 30.6327 21.1251 30.3334V15.1668C21.1251 15.1364 21.1243 15.1062 21.1226 15.0763L30.0185 8.72199ZM17.8751 17.3959L16.1113 18.6558C15.381 19.1774 14.3661 19.0083 13.8445 18.278C13.3228 17.5477 13.492 16.5328 14.2223 16.0111L28.1296 6.07735C29.448 5.13567 31.2191 5.13567 32.5373 6.07735L46.4447 16.0111C47.1748 16.5328 47.344 17.5477 46.8225 18.278C46.3008 19.0083 45.2859 19.1774 44.5555 18.6558L42.7919 17.3959V30.3334C42.7919 32.4275 41.0943 34.1251 39.0002 34.1251H21.6669C19.5727 34.1251 17.8751 32.4275 17.8751 30.3334V17.3959Z"
                            fill="#C6C6C7"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.2917 8.25563L11.851 9.81489C12.4856 10.4495 13.5145 10.4495 14.1491 9.81489C14.7836 9.1803 14.7836 8.15141 14.1491 7.5168L10.5817 3.94951C9.52409 2.89183 7.80926 2.89183 6.7516 3.94951L3.18429 7.5168C2.54969 8.15141 2.54969 9.1803 3.18429 9.81489C3.81888 10.4495 4.84779 10.4495 5.48239 9.81489L7.04167 8.25561V47.666C7.04167 48.5635 7.76922 49.291 8.66667 49.291C9.56413 49.291 10.2917 48.5635 10.2917 47.666V8.25563Z"
                            fill="#C6C6C7"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M44.4823 37.851C43.8477 37.2163 42.819 37.2163 42.1844 37.851C41.5497 38.4856 41.5497 39.5143 42.1844 40.1489L43.7435 41.7083H4.33334C3.43589 41.7083 2.70834 42.4358 2.70834 43.3333C2.70834 44.2307 3.43589 44.9583 4.33334 44.9583H43.7435L42.1844 46.5176C41.5497 47.1522 41.5497 48.181 42.1844 48.8156C42.819 49.4502 43.8477 49.4502 44.4823 48.8156L48.0497 45.2484C49.1073 44.1906 49.1073 42.4759 48.0497 41.4182L44.4823 37.851Z"
                            fill="#C6C6C7"
                        />
                    </svg>
                )}
            </div>
            <div className={cls.CardText}>
                <div title={measurement.name} className={cls.cardTitleWrapper}>
                    <span className={cls.CardTitle}>{cardTitle}</span>
                </div>
                <div className={cls.CardValues}>
                    <div className={cls.CardRow}>
                        <span className={cls.CardValuesTitle}>
                            {i18next.t('MeasurementCard.return.CardRow.floorArea')}
                        </span>
                        <span className={cls.CardValuesNumber}>
                            {String(measurement.floor_area).replace('.', ',')}{' '}
                            {i18next.t('MeasurementCard.return.CardValuesNumber.sqM')}
                        </span>
                    </div>
                    <div className={cls.CardRow}>
                        <span className={cls.CardValuesTitle}>
                            {i18next.t('MeasurementCard.return.CardRow.perimeter')}
                        </span>
                        <span className={cls.CardValuesNumber}>
                            {String(measurement.perimeter).replace('.', ',')}{' '}
                            {i18next.t('MeasurementCard.return.CardValuesNumber.m')}
                        </span>
                    </div>
                    <div className={cls.CardRow}>
                        <span className={cls.CardValuesTitle}>
                            {i18next.t('MeasurementCard.return.CardRow.wallArea')}
                        </span>
                        <span className={cls.CardValuesNumber}>
                            {String(measurement.wall_area).replace('.', ',')}{' '}
                            {i18next.t('MeasurementCard.return.CardValuesNumber.sqM')}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};
